import React from "react";
import ProjectForms from "./ProjectForms";

const EditProject = () => {

    return (
        <ProjectForms title="Edit Project" />
    )
}

export default EditProject